export default "__VITE_ASSET__DYBGNx_b__"